import { c as _c } from "react/compiler-runtime";
import { GeneralTagsSchema } from "@website/accommodation-ui/constant/schema";
import { TourCardTagsPoperties } from "@website/accommodation-ui/tour-card/tour-card-general-tags/types";
import { MiniChips, MiniChipsColorType } from "@website/ui/mini-chips";
import { FC } from "react";
export const TourCardGeneralTags: FC<TourCardTagsPoperties> = properties => {
  const $ = _c(2);
  const {
    tags
  } = properties;
  let t0;
  if ($[0] !== tags) {
    t0 = tags ? <div className="flex flex-row flex-wrap content-end gap-1">{tags.map(_temp)}</div> : null;
    $[0] = tags;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};
function _temp(t0) {
  const {
    value,
    type,
    color,
    title
  } = t0;
  return <MiniChips key={`${type}-${value}-${title}`} className="!px-2 py-1" color={type === "GENERAL" ? GeneralTagsSchema[value].color as MiniChipsColorType : color} size="medium" text={type === "GENERAL" ? GeneralTagsSchema[value].text : title} textClassName={`text-caption ${color === "#EBECF2" ? "text-on-surface-high-emphasis" : ""}`} variant="contained" />;
}